import { Box, Table, TableBody, TableCell, TableRow, TextField } from "@mui/material";
import { SimpleDekuStickItem } from "../inventory/items/DekuStickItem";
import { SimpleDekuNutItem } from "../inventory/items/DekuNutsItem";
import BombItem from "../inventory/items/BombItem";
import BowItem from "../inventory/items/BowItem";
import FireArrowItem from "../inventory/items/FireArrowItem";
import DinsFireItem from "../inventory/items/DinsFireItem";
import SlingshotItem from "../inventory/items/SlingshotItem";
import { SimpleOcarinaItem } from "../inventory/items/OcarinaItem";
import BombchusItem from "../inventory/items/BombchusItem";
import HookshotItem from "../inventory/items/HookshotItem";
import IceArrowItem from "../inventory/items/IceArrowItem";
import { SimpleFaroresWindItem } from "../inventory/items/FaroresWindItem";
import BoomrangItem from "../inventory/items/BoomrangItem";
import LensOfTruthItem from "../inventory/items/LensOfTruthItem";
import MagicBeansItem from "../inventory/items/MagicBeansItem";
import MegatonHammerItem from "../inventory/items/MegatonHammerItem";
import LightArrowItem from "../inventory/items/LightArrowItem";
import NayrusLoveItem from "../inventory/items/NayrusLoveItem";
import { CommonEmptyBottleItem } from "../inventory/items/EmptyBottle";
import MagicItem from "../inventory/items/MagicItem";
import WalletItem from "../inventory/items/WalletItem";
import ScaleItem from "../inventory/items/ScaleItem";
import StrengthItem from "../inventory/items/StrengthItem";
import KokiriSwordItem from "../inventory/items/KokiriSwordItem";
import HylianShieldItem from "../inventory/items/HylianShieldItem";
import GoronTunicItem from "../inventory/items/GoronTunicItem";
import IronBootsItem from "../inventory/items/IronBootsItem";
import BiggoronSwordItem from "../inventory/items/BiggoronSwordItem";
import MirrorShieldItem from "../inventory/items/MirrorShieldItem";
import ZoraTunicItem from "../inventory/items/ZoraTunicItem";
import HoverBootsItem from "../inventory/items/HoverBootsItem";
import TokenItemCounter from "../inventory/items/TokenCounterItem";
import ZeldaLullabySong from "../inventory/songs/ZeldaLullabySong";
import EponaSong from "../inventory/songs/EponaSong";
import SariaSong from "../inventory/songs/SariaSong";
import SunSong from "../inventory/songs/SunSong";
import TimeSong from "../inventory/songs/TimeSong";
import StormSong from "../inventory/songs/StormSong";
import MinuetOfForest from "../inventory/songs/MinuetOfForest";
import BoleroOfFire from "../inventory/songs/BoleroOfFire";
import SerenadeOfWater from "../inventory/songs/SerenadeOfWater";
import NocturneOfShadow from "../inventory/songs/NocturneOfShadow";
import RequiemOfSpirit from "../inventory/songs/RequiemOfSpirit";
import PreludeOfLight from "../inventory/songs/PreludeOfLight";
import LightMedallionItem from "../inventory/medallions/LightMedallionItem";
import ForestMedallionItem from "../inventory/medallions/ForestMedallionItem";
import FireMedallionItem from "../inventory/medallions/FireMedallionItem";
import WaterMedallionItem from "../inventory/medallions/WaterMedallionItem";
import ShadowMedallionItem from "../inventory/medallions/ShadowMedallionItem";
import SpiritMedallionItem from "../inventory/medallions/SpiritMedallionItem";
import KokiriEmeraldItem from "../inventory/medallions/KokiriEmeraldItem";
import GoronRubyItem from "../inventory/medallions/GoronRubyItem";
import ZoraSapphireItem from "../inventory/medallions/ZoraSapphireItem";
import DefaultAlwaysHint from "../hints/AlwaysHints";

import Token20 from "../../core/assets/oot/gshd/20-collected-skulltulas_32x32.png";
import Token30 from "../../core/assets/oot/gshd/30-gold-skulltula_32x32.png";
import Token40 from "../../core/assets/oot/gshd/40-gold-skulltula_32x32.png";
import Token50 from "../../core/assets/oot/gshd/50-gold-skulltula_32x32.png";
import GoronMask from "../../core/assets/oot/gshd/biggoron_32x32.png";
import Frog from "../../core/assets/oot/gshd/frogs_32x32.png";
import SkullMask from "../../core/assets/oot/gshd/skull-mask_32x32.png";
import MaskOfTruth from "../../core/assets/oot/gshd/mask-of-truth_32x32.png";
import { CommonBigPoeBottleItem } from "../inventory/items/BigPoeBottleItem";
import { BarrenHint, WothHint } from "./ReworkwothHint";
import MixPoolPlaceAutocomplete from "./MixPoolPlaceAutocomplete";
import SometimeHint from "../hints/SometimesHint";
import ZeldaImg from "../../core/assets/oot/gshd/zeldas-lullaby_32x32.png";
import BFAImg from "../../core/assets/oot/gshd/ice-arrows_32x32.png";
import CuccosImg from "../../core/assets/oot/gshd/chicken_32x32.png";
import Scarecrow from "../../core/assets/oot/classic/OoT_Scarecrow_Model.png";
import ScrubsImg from "../../core/assets/oot/classic/business_scrub.png";
import Deadge from "../../core/assets/oot/classic/deadge.png";


import {
  Dungeons,
  Grottos,
  Interiors,
  OverworldEntrances,
} from "./MixPoolNotes";
import { groupBy, sortBy } from "lodash";
import EntranceTracker from "./EntranceTracker";
import OotItemContextMenuButton from "../hints/OotItemContextMenuButton";
import PreventRefresh from "../../core/components/utils/PreventRefresh";
import { useState } from "react";
import AdditionalItemTracker from "../tracker/AdditionalItemTracker";


interface MixedPoolTrackerProps {
    dungeon: boolean,
    interior: boolean,
    overworld: boolean,
    grotto: boolean
}
const MixedPoolTracker = (props: MixedPoolTrackerProps) => {
  let grottosEntrance = [
    ...Grottos,
    ...Interiors,
    ...OverworldEntrances,
    ...Dungeons,
  ];

  grottosEntrance = sortBy(grottosEntrance, (x) => x.globalArea);

  let dic = groupBy(grottosEntrance, (x) => x.zone);

  console.log(dic);

  let [light, setLight] = useState<boolean>(false);
  let [forest, setForest] = useState<boolean>(false);
  let [fire, setFire] = useState<boolean>(false);
  let [water, setWater] = useState<boolean>(false);
  let [shadow, setShadow] = useState<boolean>(false);
  let [spirit, setSpirit] = useState<boolean>(false);
  let [deku, setDeku] = useState<boolean>(false);
  let [dc, setDc] = useState<boolean>(false);
  let [jabu, setJabu] = useState<boolean>(false);

  return (
    <Box
      overflow={"hidden"}
      onContextMenu={(e) => {
        e.preventDefault();
      }}
    >
      <PreventRefresh />
      <>Mixed Pool</>
      {/* Items */}
      {/* Line 1 */}
      <Box position={"absolute"} top={100} left={80}>
        <SimpleDekuStickItem />
      </Box>
      <Box position={"absolute"} top={100} left={112}>
        <SimpleDekuNutItem />
      </Box>
      <Box position={"absolute"} top={100} left={144}>
        <BombItem />
      </Box>
      <Box position={"absolute"} top={100} left={176}>
        <BowItem />
      </Box>
      <Box position={"absolute"} top={100} left={208}>
        <FireArrowItem />
      </Box>
      <Box position={"absolute"} top={100} left={240}>
        <DinsFireItem />
      </Box>

      {/* Line 2 */}
      <Box position={"absolute"} top={132} left={80}>
        <SlingshotItem />
      </Box>
      <Box position={"absolute"} top={132} left={112}>
        <SimpleOcarinaItem />
      </Box>
      <Box position={"absolute"} top={132} left={144}>
        <BombchusItem />
      </Box>
      <Box position={"absolute"} top={132} left={176}>
        <HookshotItem />
      </Box>
      <Box position={"absolute"} top={132} left={208}>
        <IceArrowItem />
      </Box>
      <Box position={"absolute"} top={132} left={240}>
        <SimpleFaroresWindItem />
      </Box>

      {/* Line 3 */}
      <Box position={"absolute"} top={164} left={80}>
        <BoomrangItem />
      </Box>
      <Box position={"absolute"} top={164} left={112}>
        <LensOfTruthItem />
      </Box>
      <Box position={"absolute"} top={164} left={144}>
        <MagicBeansItem />
      </Box>
      <Box position={"absolute"} top={164} left={176}>
        <MegatonHammerItem />
      </Box>
      <Box position={"absolute"} top={164} left={208}>
        <LightArrowItem />
      </Box>
      <Box position={"absolute"} top={164} left={240}>
        <NayrusLoveItem />
      </Box>

      {/* Line 4 */}
      <Box position={"absolute"} top={198} left={80}>
        <CommonBigPoeBottleItem />
      </Box>
      <Box position={"absolute"} top={198} left={112}>
        <CommonEmptyBottleItem />
      </Box>
      <Box position={"absolute"} top={198} left={144}>
        <MagicItem />
      </Box>
      <Box position={"absolute"} top={198} left={176}>
        <WalletItem />
      </Box>
      <Box position={"absolute"} top={198} left={208}>
        <ScaleItem />
      </Box>
      <Box position={"absolute"} top={198} left={240}>
        <StrengthItem />
      </Box>

      {/* Equipements */}
      {/* Line 1 */}
      <Box position={"absolute"} top={230} left={80}>
        <KokiriSwordItem />
      </Box>
      <Box position={"absolute"} top={230} left={112}>
        <HylianShieldItem />
      </Box>
      <Box position={"absolute"} top={230} left={144}>
        <GoronTunicItem />
      </Box>
      <Box position={"absolute"} top={230} left={176}>
        <IronBootsItem />
      </Box>
      <Box position={"absolute"} top={240} left={225}>
        <TokenItemCounter />
      </Box>

      {/* Line 2 */}
      <Box position={"absolute"} top={262} left={80}>
        <BiggoronSwordItem />
      </Box>
      <Box position={"absolute"} top={262} left={112}>
        <MirrorShieldItem />
      </Box>
      <Box position={"absolute"} top={262} left={144}>
        <ZoraTunicItem />
      </Box>
      <Box position={"absolute"} top={262} left={176}>
        <HoverBootsItem />
      </Box>

      {/* Songs */}
      {/* Line 1 */}
      <Box position={"absolute"} top={300} left={80}>
        <ZeldaLullabySong cleft cright cup display="horizontal" />
      </Box>
      <Box position={"absolute"} top={300} left={112}>
        <EponaSong cleft cright cup display="horizontal" />
      </Box>
      <Box position={"absolute"} top={300} left={144}>
        <SariaSong cleft cright cdown display="horizontal" />
      </Box>
      <Box position={"absolute"} top={300} left={176}>
        <SunSong cdown cright cup display="horizontal" />
      </Box>
      <Box position={"absolute"} top={300} left={208}>
        <TimeSong a cdown cright display="horizontal" />
      </Box>
      <Box position={"absolute"} top={300} left={240}>
        <StormSong a cdown cup display="horizontal" />
      </Box>

      {/* Line 2 */}
      <Box position={"absolute"} top={345} left={80}>
        <MinuetOfForest a cleft cright cup display="horizontal" />
      </Box>
      <Box position={"absolute"} top={345} left={112}>
        <BoleroOfFire a cright cdown display="horizontal" />
      </Box>
      <Box position={"absolute"} top={345} left={144}>
        <SerenadeOfWater a cleft cright cdown display="horizontal" />
      </Box>
      <Box position={"absolute"} top={345} left={176}>
        <NocturneOfShadow cdown cright cleft a display="horizontal" />
      </Box>
      <Box position={"absolute"} top={345} left={208}>
        <RequiemOfSpirit a cdown cright display="horizontal" />
      </Box>
      <Box position={"absolute"} top={345} left={240}>
        <PreludeOfLight cleft cright cup display="horizontal" />
      </Box>

      {/* Medallion and Stone */}
      <Box position={"absolute"} top={100} left={272}>
        <LightMedallionItem mixedPool isObtained={light}  setIsObtained={setLight} />
      </Box>
      <Box position={"absolute"} top={100} left={332}>
        <ForestMedallionItem mixedPool isObtained={forest}  setIsObtained={setForest}/>
      </Box>
      <Box position={"absolute"} top={100} left={392}>
        <FireMedallionItem mixedPool isObtained={fire}  setIsObtained={setFire}/>
      </Box>
      <Box position={"absolute"} top={150} left={272}>
        <WaterMedallionItem mixedPool isObtained={water}  setIsObtained={setWater}/>
      </Box>
      <Box position={"absolute"} top={150} left={332}>
        <ShadowMedallionItem mixedPool isObtained={shadow}  setIsObtained={setShadow}/>
      </Box>
      <Box position={"absolute"} top={150} left={392}>
        <SpiritMedallionItem mixedPool isObtained={spirit}  setIsObtained={setSpirit}/>
      </Box>
      <Box position={"absolute"} top={200} left={272}>
        <KokiriEmeraldItem mixedPool isObtained={deku}  setIsObtained={setDeku} />
      </Box>
      <Box position={"absolute"} top={200} left={332}>
        <GoronRubyItem mixedPool isObtained={dc}  setIsObtained={setDc}/>
      </Box>
      <Box position={"absolute"} top={200} left={392}>
        <ZoraSapphireItem mixedPool isObtained={jabu}  setIsObtained={setJabu}/>
      </Box>

      {/* Always */}
      <Box position={"absolute"} top={250} left={260}>
        <DefaultAlwaysHint hint={{ name: "ZR Frogs Ocarina Game", img: Frog }} />
      </Box>
      <Box position={"absolute"} top={250} left={380}>
        <DefaultAlwaysHint hint={{ name: "DMT Biggoron", img: GoronMask }} />
      </Box>
      <Box position={"absolute"} top={250} left={320}>
        <DefaultAlwaysHint  hint={{ name: "Kak 20 Gold Skulltula Reward", img: Token20 }}
        />
      </Box>
      <Box position={"absolute"} top={282} left={280}>
        <DefaultAlwaysHint dual dualImage={MaskOfTruth} hint={{ name: "Skull Mask", img: SkullMask }}
        />
      </Box>

      {/* Always Forest & Shadow Boss Door*/}
      <Box
        position={"absolute"}
        top={315}
        left={272}
        display={"flex"}
        alignItems={"center"}
      >
        <ForestMedallionItem hideLabel isObtained />
        <MixPoolPlaceAutocomplete
          sx={{ backgroundColor: "rgba(0,245,0,0.3)" }}
        />
      </Box>

      <Box
        position={"absolute"}
        top={348}
        left={272}
        display={"flex"}
        alignItems={"center"}
      >
        <ShadowMedallionItem hideLabel isObtained />
        <MixPoolPlaceAutocomplete
          sx={{ backgroundColor: "rgba(240,0,240,0.3)" }}
        />
      </Box>


      <Box position={"absolute"} top={380} left={500}>
        <AdditionalItemTracker adultTradeSequenceOnlyOne={true} openFountain={false} gerudoCardShuffle={false}  />
      </Box>
      {/* 5 Woth  */}
      <Box
        position={"absolute"}
        top={380}
        left={80}
        display={"flex"}
        alignItems={"center"}
      >
        {" "}
        <WothHint />
      </Box>
      <Box
        position={"absolute"}
        top={410}
        left={80}
        display={"flex"}
        alignItems={"center"}
      >
        {" "}
        <WothHint />
      </Box>
      <Box
        position={"absolute"}
        top={445}
        left={80}
        display={"flex"}
        alignItems={"center"}
      >
        {" "}
        <WothHint />
      </Box>
      <Box
        position={"absolute"}
        top={475}
        left={80}
        display={"flex"}
        alignItems={"center"}
      >
        {" "}
        <WothHint />
      </Box>
      <Box
        position={"absolute"}
        top={510}
        left={80}
        display={"flex"}
        alignItems={"center"}
      >
        {" "}
        <WothHint />
      </Box>
      {/* 3 Barrens  */}
      <Box
        position={"absolute"}
        top={545}
        left={80}
        display={"flex"}
        alignItems={"center"}
      >
        {" "}
        <BarrenHint />
      </Box>
      <Box
        position={"absolute"}
        top={580}
        left={80}
        display={"flex"}
        alignItems={"center"}
      >
        {" "}
        <BarrenHint />
      </Box>
      <Box
        position={"absolute"}
        top={615}
        left={80}
        display={"flex"}
        alignItems={"center"}
      >
        {" "}
        <BarrenHint />
      </Box>

      {/* Dual Sometimes */}
      <Box
        position={"absolute"}
        top={100}
        left={460}
        display={"flex"}
        alignItems={"center"}
      >
        <SometimeHint type="dual" />
      </Box>
      <Box
        position={"absolute"}
        top={140}
        left={460}
        display={"flex"}
        alignItems={"center"}
      >
        <SometimeHint type="dual" />
      </Box>
      <Box
        position={"absolute"}
        top={180}
        left={460}
        display={"flex"}
        alignItems={"center"}
      >
        <SometimeHint type="sometimes" />
      </Box>

      <Box
        position={"absolute"}
        top={220}
        left={460}
        display={"flex"}
        alignItems={"center"}
      >
        <SometimeHint />
      </Box>
      <Box
        position={"absolute"}
        top={260}
        left={460}
        display={"flex"}
        alignItems={"center"}
      >
        <SometimeHint />
      </Box>

 
      <Box
        position={"absolute"}
        top={540}
        left={285}
        display={"flex"}
        justifyContent={"flex-start"}
        flexDirection={"column"}
        flexWrap={"wrap"}
      >
        <Box display={"flex"}><TextField placeholder="Shop Entrance" variant="standard" sx={{width: "150px", height: "30px", maxHeight: "30px"}}/><OotItemContextMenuButton /><TextField placeholder="000" variant="standard" sx={{width: "30px", height: "30px", maxHeight: "30px"}}/><OotItemContextMenuButton /><TextField placeholder="000" variant="standard" sx={{width: "30px", height: "30px", maxHeight: "30px"}}/><OotItemContextMenuButton /><TextField placeholder="000" variant="standard" sx={{width: "30px", height: "30px", maxHeight: "30px"}}/><OotItemContextMenuButton /><TextField placeholder="000" variant="standard" sx={{width: "30px", height: "30px", maxHeight: "30px"}}/></Box>
        <Box display={"flex"}><TextField placeholder="Shop Entrance"  variant="standard" sx={{width: "150px", height: "30px", maxHeight: "30px"}}/><OotItemContextMenuButton /><TextField placeholder="000" variant="standard" sx={{width: "30px", height: "30px", maxHeight: "30px"}}/><OotItemContextMenuButton /><TextField placeholder="000" variant="standard" sx={{width: "30px", height: "30px", maxHeight: "30px"}}/><OotItemContextMenuButton /><TextField placeholder="000" variant="standard" sx={{width: "30px", height: "30px", maxHeight: "30px"}}/><OotItemContextMenuButton /><TextField placeholder="000" variant="standard" sx={{width: "30px", height: "30px", maxHeight: "30px"}}/></Box>
        <Box display={"flex"}><TextField placeholder="Shop Entrance"  variant="standard" sx={{width: "150px", height: "30px", maxHeight: "30px"}}/><OotItemContextMenuButton /><TextField placeholder="000" variant="standard" sx={{width: "30px", height: "30px", maxHeight: "30px"}}/><OotItemContextMenuButton /><TextField placeholder="000" variant="standard" sx={{width: "30px", height: "30px", maxHeight: "30px"}}/><OotItemContextMenuButton /><TextField placeholder="000" variant="standard" sx={{width: "30px", height: "30px", maxHeight: "30px"}}/><OotItemContextMenuButton /><TextField placeholder="000" variant="standard" sx={{width: "30px", height: "30px", maxHeight: "30px"}}/>      </Box>  
      </Box>
      <Box
        position={"absolute"}
        top={60}
        left={684}
        display={"flex"}
        flexDirection={"column"}
        sx={{
          msOverflowStyle: "none",
          scrollbarWidth: "none",
        }}
        maxHeight={1440}
      >
        <EntranceTracker
          grottos={true}
          interrior={true}
          overworld={true}
          dungeons={true}
          dungeonExits={true}
          displayImportantInterrior={true}
          displayOverworldEntrance={true}
          widthEnhanced
        />
      </Box>

      {/* Settings */}
      <Box
        sx={{ whiteSpace: "pre-wrap" }}
        position={"absolute"}
        top={655}
        left={80}
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
      >
        <Box> Settings: &#9;</Box>
        <Table sx={{ borderCollapse: "collapse" }}>
          <TableBody>
            <TableRow>
              <TableCell sx={{ padding: 0, paddingRight: 3 }}>
                <Box display={"flex"} alignItems={"center"}>
                  {" "}
                  <img src={ZeldaImg} alt={"ZL"} /> WOTH{" "}
                </Box>
              </TableCell>
              <TableCell sx={{ padding: 0, paddingRight: 3 }}>
                <Box display={"flex"} alignItems={"center"}>
                  {" "}
                  <img src={BFAImg} alt={"BFA"} /> BFA On{" "}
                </Box>
              </TableCell>
              <TableCell sx={{ padding: 0, paddingRight: 3 }}>
                <Box display={"flex"} alignItems={"center"}>
                  {" "}
                  <img src={CuccosImg} alt={"Cuccos"} /> : 3{" "}
                </Box>
              </TableCell>
              <TableCell sx={{ padding: 0, paddingRight: 3 }}>
                <Box display={"flex"} alignItems={"center"}>
                  {" "}
                  <img
                    src={ScrubsImg}
                    alt={"Scrubsanity"}
                    height={32}
                    width={32}
                  />{" "}
                  : Affordable{" "}
                </Box>
              </TableCell>
              <TableCell sx={{ padding: 0, paddingRight: 3 }}>
                <Box display={"flex"} alignItems={"center"}>
                  {" "}
                  Shopanity : 4{" "}
                </Box>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ padding: 0, paddingRight: 3 }}>
                <Box display={"flex"} alignItems={"center"}>
                  {" "}
                  <img src={Token30} alt={"30 Skulls"} />{" "}
                  <img src={Token40} alt={"40 Skulls"} />{" "}
                  <img src={Token50} alt={"50 Skulls"} />{" "}
                  <img src={Deadge} height={32} width={32} alt={"Dead"} />
                </Box>
              </TableCell>
              <TableCell sx={{ padding: 0, paddingRight: 3 }}>
                <Box display={"flex"} alignItems={"center"}>
                  {" "}
                  CAMC : On{" "}
                </Box>
              </TableCell>
              <TableCell sx={{ padding: 0, paddingRight: 3 }}>
                <Box display={"flex"} alignItems={"center"}>
                  {" "}
                  <img
                    src={Scarecrow}
                    alt={"Scarecrow"}
                    height={32}
                    width={32}
                  />{" "}
                  : Free{" "}
                </Box>
              </TableCell>
              <TableCell sx={{ padding: 0, paddingRight: 3 }}>
                <Box
                  display={"flex"}
                  alignItems={"center"}
                  width={100}
                  textOverflow={"wrap"}
                >
                  Open Bridge, Open Fountain, Open Deku, Open Fortress
                </Box>
              </TableCell>
              <TableCell sx={{ padding: 0, paddingRight: 3 }}>
                <Box display={"flex"} alignItems={"center"}>
                  {" "}
                  Bridge : 9 Rewards
                </Box>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell colSpan={11} sx={{ padding: 0 }}>
                <ul>
                  <li>No limit for hinted dungeons WOTH</li>
                  <li>
                    If less than 3 foolish : Stone ar filled with an extra dual
                    (and a copy if possible)
                  </li>
                  <li>
                    Shadow and Spirit Boss door can't have an overworld entrance
                  </li>
                  <li>Ganon's Tower is part of the area is connected to</li>
                  <li>DC and Deku Adult only in logic</li>
                </ul>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
};

export default MixedPoolTracker;
